export const WORKSPACE_COACHING_STYLES = ['Soft', 'Balanced', 'Direct', 'Brutal'];

export const WORKSPACE_PULSE_FREQUENCIES = ['Daily', 'Weekly'];

export const WORKSPACE_INTELLIGENCE_SENSITIVITIES = ['Low', 'Medium', 'High'];

export const WORKSPACE_PULSE_BIASES = ['Celebrate Wins', 'Balanced', 'Performance Based'];

export const EMPTY_COMPANY_VALUE = {
    name: '',
    description: '',
    expected_behavior: '',
};

export const EMPTY_PULSE_PROFILE = {
    company_values: [],
    coaching_style: '',
    pulse_frequency: '',
    intelligence_sensitivity: '',
    pulse_bias: '',
};

export const COMPANY_VALUE_NAME_PLACEHOLDER = 'Enter your Company Value. Example: People First';

export const COMPANY_VALUE_DESCRIPTION_PLACEHOLDER = `Describe what the value means to your organisation.
Example: Support colleagues, clients and stakeholders.`;

export const COMPANY_VALUE_BEHAVIOR_PLACEHOLDER = `Describe the expected behaviour from team members reflecting the value.
Example: Remove blockers quickly and help others move work forward.`;

export const PULSE_FIELD_META = {
    coaching_style: {
        label: 'Coaching Style',
        description: 'Determines how directly Lens communicates accountability, priorities and performance observations.',
        options: WORKSPACE_COACHING_STYLES,
    },
    pulse_frequency: {
        label: 'Pulse Frequency',
        description: 'How often Lens Pulse briefings are generated for users.',
        options: WORKSPACE_PULSE_FREQUENCIES,
    },
    intelligence_sensitivity: {
        label: 'Intelligence Sensitivity',
        description: 'Controls how aggressively Lens surfaces patterns, anomalies and emerging themes.',
        options: WORKSPACE_INTELLIGENCE_SENSITIVITIES,
    },
    pulse_bias: {
        label: 'Pulse Bias',
        description: 'Influences whether Lens focuses primarily on achievements, balance, or performance and accountability.',
        options: WORKSPACE_PULSE_BIASES,
    },
};

export const normalizeCompanyValues = values => {
    if (!Array.isArray(values)) {
        return [];
    }
    return values
        .map(item => ({
            name: (item?.name || '').trim(),
            description: (item?.description || '').trim(),
            expected_behavior: (item?.expected_behavior || '').trim(),
        }))
        .filter(item => item.name || item.description || item.expected_behavior);
};

export const normalizePulseProfile = profile => ({
    company_values: normalizeCompanyValues(profile?.company_values),
    coaching_style: (profile?.coaching_style || '').trim(),
    pulse_frequency: (profile?.pulse_frequency || '').trim(),
    intelligence_sensitivity: (profile?.intelligence_sensitivity || '').trim(),
    pulse_bias: (profile?.pulse_bias || '').trim(),
});

export const pulseProfileFromApi = data => normalizePulseProfile(data);

export const editingPulseFlagsFromSaved = saved => ({
    coaching_style: !saved.coaching_style,
    pulse_frequency: !saved.pulse_frequency,
    intelligence_sensitivity: !saved.intelligence_sensitivity,
    pulse_bias: !saved.pulse_bias,
});

export const PULSE_PREFERENCE_KEYS = ['coaching_style', 'pulse_frequency', 'intelligence_sensitivity', 'pulse_bias'];

export const PROFILE_PATCH_KEYS = [
    'org_type',
    'org_description',
    'offerings',
    'ideal_customer_profile',
    'company_values',
    ...PULSE_PREFERENCE_KEYS,
];
